/**
 * Gets an encoded path segment
 * @param {string} planSize - Current plan size
 * @param {array} array - available plans
 * @example
 * // returns 35
 * const minPlanCost = getPlanMinCost('1-2', plansData.plans = []);
 * @returns {string} minimum plan cost
 */
const getPlanMinCost = (planSize = '', plans = []) =>
    plans.reduce((prevSum, nextPlan) => prevSum + nextPlan.planSizes[planSize].minBoxRange, 0).toFixed(2);

/**
 * Check for valid planPreferences requires a plan size and a minPlanCost of $35
 * @param {object} availablePlans - Response from plan data object
 * @param {object} planPreferences - Active preferences
 * @param {number} orderMin - Order minimum
 * @example
 * // returns true
 * const preferencesValid = isPlanPreferencesValid(plansData, plansPreferences, 35);
 * @returns {bool}
 */
const isPlanPreferencesValid = (availablePlans, planPreferences, orderMin) => {
    if (!planPreferences?.planSize) return false;

    const planIDs = planPreferences?.plans.map((plan) => plan.id);
    const plans = availablePlans?.plans?.filter((availablePlan) => planIDs.includes(availablePlan.id));
    const planMinCost = getPlanMinCost(planPreferences.planSize, plans);

    return planMinCost >= orderMin;
};

/**
 * Check for valid planPreferences requires a plan size and a minPlanCost of $35
 * @param {object} availablePlans - Response from plan data object
 * @param {object} selectedAddOnPlans - Active preferences
 * @param {object} selectedBasePlan - Active base plan
 * @param {number} orderMin - Order minimum
 * @example
 * // returns true
 * const preferencesValid = isIFPlanPreferencesValid(plansData, plansPreferences, { id: "21", name: "Fruit", size: "Small" }, 35);
 * @returns {bool}
 */
const isIFPlanPreferencesValid = (availablePlans, selectedAddOnPlans, selectedBasePlan, orderMin) => {
    const planIDs = selectedAddOnPlans.map((plan) => plan.id);
    const plans = availablePlans?.addOnPlans?.filter((availablePlan) => planIDs.includes(availablePlan.id));
    const planMinCost = plans?.reduce((prevSum, nextPlan) => prevSum + nextPlan.minBoxRange, 0).toFixed(2);

    const basePlan = availablePlans.basePlans?.filter((plan) => plan.id === Number(selectedBasePlan.id))[0] || {};
    const selectedBasePlanMin = basePlan.planSizes[selectedBasePlan.size].minBoxRange;

    return Number(planMinCost) + selectedBasePlanMin >= orderMin;
};

export { getPlanMinCost, isIFPlanPreferencesValid, isPlanPreferencesValid };
